// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"Faults_wrpr__L9vFC","faultCard":"Faults_faultCard__XlRdG","js-has-pseudo":"Faults_js-has-pseudo__tJcfn"};